import { features } from '@/mocks/categories';

export default function FeaturesSection() {
  return (
    <section id="why-choose" className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-secondary-100 text-secondary-800 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            Why Choose Us
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Why Choose Sugargoo Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Our platform combines powerful product discovery with educational resources to help you shop smarter.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-100 border border-background-200/70 rounded-lg p-6 md:p-7 hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}